import { Link, useLocation } from "react-router-dom";

import { Col, Avatar, Badge, Menu } from "antd";

import menuImg from "@assets/images/pages/profile/menu-img.svg";
import avatar from "@assets/images/memoji/user1.png";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const MenuProfile = (props) => {
  const { user } = useSelector((state) => state.auth);
  const location = useLocation();
  const { pathname } = location;
  const splitLocation = pathname.split("/");

  const { t } = useTranslation();

  const menuIconClass = "remix-icon hp-mr-8";

  const menuFooterItem = () => {
    if (props.footer !== "none") {
      return (
        <div className="hp-profile-menu-footer">
          <img src={menuImg} alt="Profile" />
        </div>
      );
    }
  };

  const moreBtn = () => {
    if (props.moreBtnCheck !== "none") {
      return (
        <Col className="hp-menu-header-btn hp-pr-16 hp-mb-12 hp-text-right">
          {props.moreBtn()}
        </Col>
      );
    }
  };

  const LanguageIcon = () => (
    <div style={{ marginRight: "6px", marginTop: "3px" }}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        className={menuIconClass}
      >
        <g
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        >
          <path d="M4 21V8a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H8z" />
          <path d="M10 14v-4a2 2 0 1 1 4 0v4m0-2h-4" />
        </g>
      </svg>
    </div>
  );

  return (
    <Col
      className="hp-profile-menu hp-py-24"
      style={{
        position: "fixed",
        top: 0,
        width: "320px",
      }}
    >
      <div className="hp-w-100">
        <div className="hp-profile-menu-header hp-mt-md-16 hp-text-center">
          {moreBtn()}

          <Badge>
            <Avatar size={80} src={avatar} />
          </Badge>

          <h3 className="hp-mt-24 hp-mb-4">{user?.name}</h3>
          <a href={`mailto:${user?.email}`} className="hp-p1-body">
            {user?.email}
          </a>
        </div>

        <Menu
          mode="inline"
          className="hp-w-100 hp-profile-menu-body custom-scroll-bar"
          theme={"light"}
          style={{
            overflowY: "auto",
            height: "calc(100vh - 290px)",
            overflowX: "hidden",
          }}
        >
          {/* Personal Information */}
          <Menu.Item
            key="1"
            icon={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="25"
                height="25"
                viewBox="0 0 24 24"
              >
                <g
                  fill="none"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                >
                  <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
                  <circle cx="12" cy="7" r="4" />
                </g>
              </svg>
            }
            className={`
              hp-mb-16 hp-pl-24 hp-pr-32
              ${
                splitLocation[splitLocation.length - 1] === "information"
                  ? "ant-menu-item-selected"
                  : "ant-menu-item-selected-in-active"
              }
            `}
            onClick={props.onCloseDrawer}
          >
            <Link to="/profile/information">
              {t("profile.plans.personalInformation")}
            </Link>
          </Menu.Item>

          {/* Plans & Pricing */}
          {(user?.role === "admin" || user?.role === "superadmin") && (
            <Menu.Item
              key="2"
              icon={
                <svg
                  className={menuIconClass}
                  style={{
                    height: "24px",
                    width: "24px",
                  }}
                  viewBox="0 0 20 16"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill="#636E71"
                    d="M19.25 0h-6c-.412 0-.989.239-1.28.53L4.531 7.969a.752.752 0 0 0 0 1.061l6.439 6.439a.752.752 0 0 0 1.061 0L19.47 8.03c.292-.292.53-.868.53-1.28v-6a.752.752 0 0 0-.75-.75M15.5 6a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 15.5 6"
                  />
                  <path
                    fill="#636E71"
                    d="M2 8.5L10.5 0H9.25c-.412 0-.989.239-1.28.53L.531 7.969a.752.752 0 0 0 0 1.061l6.439 6.439a.752.752 0 0 0 1.061 0l.47-.47z"
                  />
                </svg>
              }
              className={`
              hp-mb-16 hp-pl-24 hp-pr-32
              ${
                splitLocation[splitLocation.length - 1] === "plans"
                  ? "ant-menu-item-selected"
                  : "ant-menu-item-selected-in-active"
              }
            `}
              onClick={props.onCloseDrawer}
            >
              <Link to="/profile/plans">
                {t("profile.plans.plans&Pricing")}
              </Link>
            </Menu.Item>
          )}

          {/* Subscription */}
          {user?.role === "admin" && (
            <Menu.Item
              key="3"
              icon={
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="25"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="currentColor"
                    d="M11 4H4v7l9 9.01L20 13l-9-9zM6.5 8C5.67 8 5 7.33 5 6.5S5.67 5 6.5 5S8 5.67 8 6.5S7.33 8 6.5 8z"
                    opacity=".3"
                  />
                  <path
                    fill="currentColor"
                    d="M12.41 2.58C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58s1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41s-.23-1.06-.59-1.42l-9-9zM13 20.01L4 11V4h7v-.01l9 9l-7 7.02z"
                  />
                  <circle cx="6.5" cy="6.5" r="1.5" fill="currentColor" />
                </svg>
              }
              className={`
              hp-mb-16 hp-pl-24 hp-pr-32
              ${
                splitLocation[splitLocation.length - 1] === "subscription"
                  ? "ant-menu-item-selected"
                  : "ant-menu-item-selected-in-active"
              }
            `}
              onClick={props.onCloseDrawer}
            >
              <Link to="/profile/subscription">
                {t("profile.plans.mySubscription")}
              </Link>
            </Menu.Item>
          )}

          {/* Language */}
          {user?.role === "admin" && (
            <Menu.Item
              key="4"
              icon={<LanguageIcon />}
              className={`
              hp-mb-16 hp-pl-24 hp-pr-32
              ${
                splitLocation[splitLocation.length - 1] === "language"
                  ? "ant-menu-item-selected"
                  : "ant-menu-item-selected-in-active"
              }
            `}
              onClick={props.onCloseDrawer}
            >
              <Link to="/profile/language">
                {t("profile.plans.changeLanguage")}
              </Link>
            </Menu.Item>
          )}

          {/* Security */}
          <Menu.Item
            key="5"
            icon={
              <svg
                className={menuIconClass}
                xmlns="http://www.w3.org/2000/svg"
                width="25"
                height="25"
                viewBox="0 0 24 24"
              >
                <path
                  fill="currentColor"
                  d="M19.9 12.66a1 1 0 0 1 0-1.32l1.28-1.44a1 1 0 0 0 .12-1.17l-2-3.46a1 1 0 0 0-1.07-.48l-1.88.38a1 1 0 0 1-1.15-.66l-.61-1.83a1 1 0 0 0-.95-.68h-4a1 1 0 0 0-1 .68l-.56 1.83a1 1 0 0 1-1.15.66L5 4.79a1 1 0 0 0-1 .48L2 8.73a1 1 0 0 0 .1 1.17l1.27 1.44a1 1 0 0 1 0 1.32L2.1 14.1a1 1 0 0 0-.1 1.17l2 3.46a1 1 0 0 0 1.07.48l1.88-.38a1 1 0 0 1 1.15.66l.61 1.83a1 1 0 0 0 1 .68h4a1 1 0 0 0 .95-.68l.61-1.83a1 1 0 0 1 1.15-.66l1.88.38a1 1 0 0 0 1.07-.48l2-3.46a1 1 0 0 0-.12-1.17ZM18.41 14l.8.9l-1.28 2.22l-1.18-.24a3 3 0 0 0-3.45 2L12.92 20h-2.56L10 18.86a3 3 0 0 0-3.45-2l-1.18.24l-1.3-2.21l.8-.9a3 3 0 0 0 0-4l-.8-.9l1.28-2.2l1.18.24a3 3 0 0 0 3.45-2L10.36 4h2.56l.38 1.14a3 3 0 0 0 3.45 2l1.18-.24l1.28 2.22l-.8.9a3 3 0 0 0 0 3.98Zm-6.77-6a4 4 0 1 0 4 4a4 4 0 0 0-4-4Zm0 6a2 2 0 1 1 2-2a2 2 0 0 1-2 2Z"
                />
              </svg>
            }
            className={`
              hp-mb-16 hp-pl-24 hp-pr-32
              ${
                splitLocation[splitLocation.length - 1] === "security"
                  ? "ant-menu-item-selected"
                  : "ant-menu-item-selected-in-active"
              }
            `}
            onClick={props.onCloseDrawer}
          >
            <Link to="/profile/security">
              {t("profile.plans.securitySettings")}
            </Link>
          </Menu.Item>

          {/* Password Change */}
          <Menu.Item
            key="6"
            icon={
              <svg
                className={menuIconClass}
                xmlns="http://www.w3.org/2000/svg"
                width="25"
                height="25"
                viewBox="0 0 24 24"
              >
                <path
                  fill="currentColor"
                  d="M3 19q-.425 0-.713-.288T2 18q0-.425.288-.713T3 17h18q.425 0 .713.288T22 18q0 .425-.288.713T21 19H3Zm-.5-6.425q-.275-.15-.35-.45t.075-.575l.475-.85h-.95q-.325 0-.537-.212T1 9.95q0-.325.213-.537T1.75 9.2h.95l-.475-.8q-.15-.275-.075-.575t.35-.45q.275-.15.575-.075t.45.35l.475.8l.475-.8q.15-.275.45-.35t.575.075q.275.15.35.45t-.075.575l-.475.8h.95q.325 0 .537.213T7 9.95q0 .325-.213.538t-.537.212H5.3l.475.85q.15.275.075.575t-.35.45q-.275.15-.575.075t-.45-.35L4 11.45l-.475.85q-.15.275-.45.35t-.575-.075Zm8 0q-.275-.15-.35-.45t.075-.575l.475-.85h-.95q-.325 0-.537-.212T9 9.95q0-.325.213-.537T9.75 9.2h.95l-.475-.8q-.15-.275-.075-.575t.35-.45q.275-.15.575-.075t.45.35l.475.8l.475-.8q.15-.275.45-.35t.575.075q.275.15.35.45t-.075.575l-.475.8h.95q.325 0 .537.213T15 9.95q0 .325-.213.538t-.537.212h-.95l.475.85q.15.275.075.575t-.35.45q-.275.15-.575.075t-.45-.35L12 11.45l-.475.85q-.15.275-.45.35t-.575-.075Zm8 0q-.275-.15-.35-.45t.075-.575l.475-.85h-.95q-.325 0-.537-.212T17 9.95q0-.325.213-.537t.537-.213h.95l-.475-.8q-.15-.275-.075-.575t.35-.45q.275-.15.575-.075t.45.35l.475.8l.475-.8q.15-.275.45-.35t.575.075q.275.15.35.45t-.075.575l-.475.8h.95q.325 0 .537.213T23 9.95q0 .325-.213.538t-.537.212h-.95l.475.85q.15.275.075.575t-.35.45q-.275.15-.575.075t-.45-.35L20 11.45l-.475.85q-.15.275-.45.35t-.575-.075Z"
                />
              </svg>
            }
            className={`
              hp-mb-16 hp-pl-24 hp-pr-32
              ${
                splitLocation[splitLocation.length - 1] === "password"
                  ? "ant-menu-item-selected"
                  : "ant-menu-item-selected-in-active"
              }
            `}
            onClick={props.onCloseDrawer}
          >
            <Link to="/profile/password">
              {t("profile.plans.changePassword")}
            </Link>
          </Menu.Item>
        </Menu>
      </div>

      {menuFooterItem()}
    </Col>
  );
};

export default MenuProfile;
